import {
    MultidimensionalAllocationDataSourcesState
} from "src/services/multidimensional-allocation/data-sources/MultidimensionalAllocationDataSourcesState";
import React from "react";
import TPEAction from "src/models/common/TPEAction";
import ServiceCollection from "src/services/ServiceCollection";
import {
    MultidimensionalAllocationState
} from "src/services/multidimensional-allocation/MultidimensionalAllocationState";

export type MultidimensionalAllocationDataSourceContextType = {
    multidimensionalAllocationDataSourcesState: MultidimensionalAllocationDataSourcesState,
    multidimensionalAllocationDataSourceDispatch: React.Dispatch<TPEAction>,
    services: ServiceCollection,
    multidimensionalAllocationState: MultidimensionalAllocationState
}

export const MultidimensionalAllocationDataSourceContext = React.createContext(null as unknown as MultidimensionalAllocationDataSourceContextType);